import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import VueRouter from "vue-router";
import VuetifyMoney from "vuetify-money";

import Auth from "./components/auth/Auth";
import ListaClientes from "./components/clientes/Lista";
import Inicio from "./components/inicio/Inicio";
import Dashboard from "./components/dashboard/Dashboard";
import Faturas from "./components/faturas/Faturas";
import Tickets from "./components/tickets/Tickets";
import Faturamento from "./components/faturas/Faturamento";
import Calculadora from "./components/calculadora/Calculadora";
import Sucesso from "./components/sucesso/Sucesso";
import Erro from "./components/erro/Erro";

import { isAdmin } from "./utils/utils";

import NumAbbr from "number-abbreviate";

import "./styles/markdown.css";

import packageJson from '../package.json';

function loadWhaticket() {
  if (typeof window === "undefined") return Promise.reject(new Error("Not in browser"));

  window.WTT_API = {
    config: {
      token: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJjb21wYW55SWQiOiI4MWU1NWJkOC1kNDIwLTRmZWYtOTc5OC1iYjk1OGIxZDkwYWUiLCJjb25uZWN0aW9uSWQiOiJmYWE4ODA2ZC02NWM0LTQxOTUtYTczOS03ZDBhODA2NzZkZjYiLCJpYXQiOjE3NjIzODg3MTB9.0_LCBFGpcdVfXltrCcLj0k1hfpBkqC--d6iBHdVqdcE",

      title: "Atendimento 💬",
      subtitle: "Normalmente responde em alguns minutos... ",
      position: "right",
      toggleButtonEnabled: true,
      toggleButtonBgColor: "#3956ff",

      requestName: true,
      requestEmail: false,
      requestNumber: true,

      initialMessages: [
        "",
        "",
      ],

      isAudioEnabled: false,
    },
  };

  if (document.querySelector('script[data-whaticket="1"]')) {
    return Promise.resolve();
  }

  return new Promise((resolve, reject) => {
    const s = document.createElement("script");
    s.src = "https://public.whaticket.com/widget/production/wtt-widget-default.js";
    s.async = true;
    // use "anonymous" ou remova; não use "*"
    s.crossOrigin = "*";
    s.dataset.whaticket = "1";
    s.onload = () => {
      // opcional: tiny delay para o widget inicializar internamente
      setTimeout(() => resolve(), 50);
    };
    s.onerror = (err) => reject(new Error("Failed to load Whaticket widget: " + err));
    document.head.appendChild(s);
  });
}
Vue.config.productionTip = false;

const { host } = window.location;
const isRevenda = !/painel\.gamadelivery\.app|painel\.gamatecnologias\.com\.br/g.test(host);
if (isRevenda) {
  loadWhaticket()
    .then(() => {
      console.log("Chat carregado...");
    })
    .catch((err) => {
      console.error(err);
    });
}

Vue.use(VueRouter);
Vue.use(VuetifyMoney);

const router = new VueRouter({
  routes: [
    {
      path: "/",
      name: "Auth",
      component: Auth,
    },
    {
      path: "/faturas/:asaas_id_revenda",
      name: "Faturas",
      component: Faturas,
      meta: { admin: true },
    },
    {
      path: "/inicio/",
      name: "Inicio",
      component: Inicio,
    },
    {
      path: "/dashboard/",
      name: "Dashboard",
      component: Dashboard,
      meta: { admin: true },
    },
    {
      path: "/lista/",
      name: "ListaClientes",
      component: ListaClientes,
    },
    {
      path: "/tickets/",
      name: "Tickets",
      component: Tickets,
    },
    {
      path: "/faturamento/",
      name: "Faturamento",
      component: Faturamento,
      meta: { admin: true },
    },
    {
      path: "/calculadora/",
      name: "Calculadora",
      component: Calculadora,
      meta: { admin: true },
    },
    {
      path: "/sucesso/",
      name: "Sucesso",
      component: Sucesso,
    },
    {
      path: "/erro/",
      name: "Erro",
      component: Erro,
    },
    {
      path: "*",
      component: () => import("./components/PaginaNaoEncontrada404"),
    },
  ],
});

/**
 * Rotas com meta.admin so abrem para o perfil administrador.
 * O bloqueio de verdade e no backend, aqui e so navegacao.
 */
router.beforeEach((to, from, next) => {
  if (to.matched.some((rota) => rota.meta && rota.meta.admin) && !isAdmin()) {
    return next({ path: "/lista/" });
  }

  return next();
});

Vue.config.productionTip = false;

Vue.mixin({
  data: function () {
    return {
      get versao() {
        return packageJson.version;
      },
      get isRevenda() {
        return isRevenda;
      },
      get isAdmin() {
        return isAdmin();
      },
      get valorRevenda() {
        return 60.00;
      },
      get valorFiscal() {
        return 50.00;
      },
      get valorGamaZap() {
        return 0.00;
      },
      get valorGamaZapCampanhas() {
        return 15.00;
      },
      get valorSuporte() {
        return 25.00;
      },
      get valorGtef() {
        return 30.00;
      },
      get valorGtefSitef() {
        return 80.00;
      },
      get valorGtefScope() {
        return 70.00;
      },
      get valorGpos() {
        return 30.00;
      },
      get valorGmesas() {
        return 30.00;
      },
      get valorGtotem() {
        return 30.00;
      },
      get valorRobo() {
        return 10.00;
      },
      get valorMinimoRevenda() {
        return 300.00;
      },
      get qtdMinimoLojasRevenda() {
        return 5.00;
      },
      get isDesenvolvimento() {
        return process.env.NODE_ENV === "development";
      },
      get baseUrl() {
        var parts = window.location.host.split('.');
        parts.shift();

        return this.isDesenvolvimento
          ? ".gamadelivery.app"
          : `.${parts.join('.')}`;
      },
      get urlCadastro() {
        let { host } = window.location;

        return this.isDesenvolvimento
          ? ".gamadelivery.app"
          : host.replace("painel", "");
      },
      get dominio() {
        return this.isDesenvolvimento
          ? "painel-dev.gamadelivery.app"
          : window.location.host;
      },
      get planos() {
        return [
          { value: 0, text: 'Personalizado' },
          { value: 1, text: 'Essencial' },
          { value: 2, text: 'Profissional' },
          { value: 3, text: 'Avançado' }
        ];
      }
    };
  },
});

Vue.filter("formatNumber", (value) => {
  var numAbbr = new NumAbbr();
  return numAbbr.abbreviate(value, 2);
});

Vue.filter("capitalize", (value) => {
  return value.charAt(0).toUpperCase() + value.slice(1);
});

Vue.filter("formatPhone", (telefone) => {
  if (!telefone) {
    return telefone;
  }

  if (/@g\.us/i.test(telefone)) {
    return telefone;
  }

  let tel = telefone.split(/[:@]/).filter(Boolean)[0];
  tel = tel.replace(/[^0-9]/g, "");

  switch (tel.length) {
    case 10:
      return `(${tel.substr(0, 2)}) ${tel.substr(2, 4)}-${tel.substr(6, 4)}`;
    case 11:
      return `(${tel.substr(0, 2)}) ${tel.substr(2, 1)} ${tel.substr(3, 4)}-${tel.substr(7, 4)}`;
    case 12:
      return `(${tel.substr(2, 2)}) ${tel.substr(4, tel.length - 8)}-${tel.substr(-4)}`;
    case 13:
      return `(${tel.substr(2, 2)}) ${tel.substr(4, 1)} ${tel.substr(5, tel.length - 9)}-${tel.substr(-4)}`;
    default:
      return telefone;
  }
});

new Vue({
  router,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");